import * as types from "@/store/taxcode/types";
import {
  listTaxcode,
  createTaxcode,
  updateTaxcode,
  deleteTaxcode
} from "@/services/taxcode";

function resolveListQuery(payload) {
  if (payload && typeof payload === "object" && !Array.isArray(payload)) {
    if ("page" in payload || "limit" in payload) {
      return {
        page: Number(payload.page) || 1,
        limit: Number(payload.limit) || 10,
      };
    }
  }
  return { page: 1, limit: 500 };
}

export default {
  async fetchTaxcodeListforTenant({ commit }, payload) {
    try {
      const query = resolveListQuery(payload);
      const data = await listTaxcode(query);
      const list = Array.isArray(data.response) ? data.response : [];
      commit(types.SET_TAXCODELIST, list);
      if (data.meta) {
        commit(types.SET_TAXCODEMETA, data.meta);
      } else {
        commit(types.SET_TAXCODEMETA, {
          total: list.length,
          currentPage: `${query.page}`,
          perPage: `${query.limit}`,
        });
      }
      return data;
    } catch (error) {
      throw error;
    }
  },

  async createTaxcode({ commit }, payload) {
    try {
      const data = await createTaxcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async updateTaxcode({ commit }, payload) {
    try {
      const data = await updateTaxcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async deleteTaxcode({ commit }, payload) {
    try {
      const data = await deleteTaxcode(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async setTaxcodeObject({ commit }, payload) {
    try {
      commit(types.SET_TAXCODEOBJECT, payload);
      return payload;
    } catch (error) {
      throw error;
    }
  },
};
